import { render, staticRenderFns } from "./TrafficShare.vue?vue&type=template&id=1ada55fe&"
import script from "./TrafficShare.vue?vue&type=script&lang=js&"
export * from "./TrafficShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports